import { MuiStylesType } from 'model/muiStyles.model';
import zeplinColor from 'theme/Color';

export const muiStyles: MuiStylesType = {
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    overflow: 'scroll',
    flex: 1,
    gap: '16px',
  },

  stage: {
    minWidth: '300px',
    width: '100%',
    borderRadius: '14px 14px 0 0',
    padding: '8px',
    backgroundColor: zeplinColor.Neutral2,
  },

  stageHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 12px 8px 0px',
    marginBottom: '8px',
  },

  stageAmount: { color: zeplinColor.Success },

  stageColumn: {
    height: 'calc(100vh - 380px)',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
};
